import axios from "axios";
import { URLEndpoints } from "../../constants/urlConstants";

export const getTaxes = async () => {
    try {
        const response=await axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/${URLEndpoints.tax}`);
        return response.data
    } catch (error) {
        console.log(error)
    }
}